// UTILS
import { ref } from "vue"
import { defineStore } from "pinia"

// HELPERS
import { sleep } from "@/helpers/sleep"

// STORES
import { useBrainStore } from "@/features/brain/stores/brain.store"

export const useBrainTutoStore = defineStore("brainTutoStore", () => {
  const isTutorial = ref(true) // default true - false for testing
  const isTutoError = ref(false)
  const isTutoEndModalOpen = ref(false)
  const tutoAnswerIsPlaying = ref(false)
  const tutoIsReady = ref(false)
  const currentTutoStep = ref(0)
  const instructionsDone = ref(false)

  /**
   * Restart the tutorial
   */
  function restartTutorial() {
    isTutorial.value = true
    currentTutoStep.value = 0
  }

  function openTutoEndModal() {
    isTutoEndModalOpen.value = true
  }

  function closeTutoEndModal() {
    isTutoEndModalOpen.value = false
  }

  /**
   * Reveal the answer for the current tutorial step
   */
  async function revealAnswer() {
    // The animation disables canvas interactions and only restores them in its
    // own timeout: replaying it concurrently makes the second timeout bail out
    // early, leaving the canvas permanently unclickable
    if (tutoAnswerIsPlaying.value || !tutoIsReady.value) return
    tutoAnswerIsPlaying.value = true

    const brain = useBrainStore()
    brain.rawResetTest()
    await new Promise((resolve) => requestAnimationFrame(resolve))
    void brain.playAnswer(currentTutoStep.value)
  }

  /**
   * Submit the current tutorial step
   */
  async function submitTutoStep() {
    useBrainStore().onSubmitTutoStep()
  }

  /**
   * Open the tutorial error modal
   */
  async function openTutoErrorModal() {
    isTutoError.value = true
    await sleep(2000)
    isTutoError.value = false
  }

  /**
   * Acknowledge the tutorial error once it has been handled by the view
   */
  function consumeTutoError() {
    isTutoError.value = false
  }

  return {
    isTutorial,
    isTutoError,
    isTutoEndModalOpen,
    tutoAnswerIsPlaying,
    tutoIsReady,
    currentTutoStep,
    instructionsDone,
    revealAnswer,
    submitTutoStep,
    openTutoErrorModal,
    consumeTutoError,
    openTutoEndModal,
    closeTutoEndModal,
    restartTutorial,
  }
})
